@if (isLoading) {
<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>

<div class="panel-title-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
<div class="panel-dummy">
  <div class="shine"></div>
</div>
}
@else {
<h2 class="panel-title">{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.TitleXpacInfo' | translate }}</h2>

<form class="form-container" [formGroup]="formGroupXPACInfo">
  <app-input formControlName="deviceId"
    label="{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.DeviceId' | translate }}"></app-input>
  <app-input formControlName="firmware"
    label="{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.Firmware' | translate }}"></app-input>
  <app-input formControlName="installationDate" type="date"
    label="{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.InstallationDate' | translate }}"></app-input>
  <app-input formControlName="shardId"
    label="{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.ShardId' | translate }}"></app-input>
</form>

<h2 class="panel-title">{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.Companies' | translate }}</h2>

<form class="form-container" [formGroup]="formGroupCompanies">
  <app-input type="menu" (click)="openCompaniesFilterDialog(CompanyType.Dealer)" formControlName="dealer"
    label="{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.Partner' | translate}}">
  </app-input>

  <app-input type="menu" (click)="openCompaniesFilterDialog(CompanyType.Retailer)" formControlName="retailer"
    label="{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.Retailer' | translate}}">
  </app-input>
</form>

<!-- Add linkedparter button -->
<p *ngIf="hasLocalInstallerAccess()" class="p-formfield-info">{{
  'Modules.XPACManagementComponent.XpacDetailsComponent.LocalAccessDisclaimer' | translate}}</p>

<div class="action-buttons" *ngIf="canEditLinkedCompanies()">
  <button [disabled]="!canAddLinkedCompany()" mat-flat-button class="button small-button clickable"
    (click)="openCompaniesFilterDialog(CompanyType.Installer)">
    <mat-icon>add</mat-icon>
    <p>{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.LinkedCompanies' | translate }}</p>
  </button>
</div>

<ng-container *ngFor="let company of linkedCompanies">
  <app-list-item title="{{ getLinkedCompanyDescription(company) }}" [showItemStatus]="false"
    [actionIcon]="{icon: 'delete'}" [showActionIcon]="canEditLinkedCompanies()"
    (onActionClickCallback)="removeLinkedCompany(company)">
  </app-list-item>
</ng-container>

<!-- XPAC SSH password request -->
@if (canRequestPassword()) {
<h2 class="panel-title">{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.Password' | translate }}</h2>

<form class="form-container" [formGroup]="formGroupPassword" *ngIf="hasPassword">
  <app-input formControlName="password"
    label="{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.Password' | translate }}"
    suffixIcon="content_copy" (suffixClick)="copyPasswordToClipboard()"></app-input>
</form>
<div class="action-buttons" *ngIf="!hasPassword">
  <button mat-flat-button class="button small-button clickable" [disabled]="hasPassword || gettingPassword"
    (click)="getPassword()">
    <mat-icon>key</mat-icon>
    <p>{{ 'Modules.XPACManagementComponent.XpacDetailsComponent.GetPassword' | translate }}</p>
  </button>
</div>
}
}